import { render, staticRenderFns } from "./NotificationsView.vue?vue&type=template&id=270869ac&scoped=true&"
import script from "./NotificationsView.vue?vue&type=script&lang=ts&"
export * from "./NotificationsView.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsView.vue?vue&type=style&index=0&id=270869ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270869ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
